
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";

export default BaseCmsBlock.extend({
  name: "BannerDiscountTransportTemplateBlock",

  computed: {
    phoneNumber: function () {
      return this.$store.state?.appState?.vars?.['Телефон']
    }
  }
})
